<template>
    <div class="row">
        <!-- SCREEN 1 -->
        <div v-if="screen == 1" class="col-sm-12 col-md-8">
            <span
                class="text-underline cursor-pointer text-muted"
                style="position: absolute; top: -25px"
                @click="$router.back()"
                ><i class="fa fa-arrow-left" aria-hidden="true"></i> Go
                back</span
            >
            <h3 class="mb-0">Edit Order #{{ orderInfo.id }}</h3>
            <p>
                Add items by SKU or search using product name or feature. Can't
                find what you need? <u>Contact your representative.</u>
            </p>
            <div class="row">
                <div class="col-md-4">
                    <label class="text-muted">PO Number</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="po_number"
                        placeholder="Input PO Number"
                        autocomplete="off"
                        required
                    />
                </div>
                <div class="col-md-8"></div>
            </div>
            <div class="row mt-3">
                <div class="col-md-4">
                    <label class="text-muted">Attach PO</label>
                    <input
                        type="file"
                        name="thumbnail"
                        @change="onChangeThumbnail"
                        class="form-control"
                        accept=".pdf"
                        required
                        autofocus
                    />
                </div>
                <div class="text-danger" v-if="showPoAttachError">
                    PO Attachment is required
                </div>
                <!-- <div class="col-md-4">
                    <div class="preview-container mt-4" v-if="thumbnail.length">
                        <div
                            v-for="file in thumbnail"
                            :key="file.name"
                            class="preview-card"
                        >
                            <img
                                class="preview-img3"
                                style="height: 10ch"
                                :src="generateURL(file)"
                            />
                        </div>
                    </div>
                    <div class="preview-container mt-4" v-else>
                        <div class="preview-card">
                            <img
                                class="preview-img3"
                                style="height: 10ch; width: auto"
                                :src="thumbnailTemp"
                            />
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="row mt-3">
                <div class="col-md-4">
                    <label class="text-muted">Requested Delivery Date</label>
                    <datepicker
                        class="form-control"
                        v-model="requestedDeliveryDate"
                        :lower-limit="lowerLimit"
                    />
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-3 col-md-12">
                    <label>Pricelist:</label>
                </div>
                <div class="col-sm-9 col-md-12">
                    <span v-if="orderInfo.pricelist != null">
                        <strong class="font-weight-bold">{{
                            orderInfo.pricelist.pricelist_name
                        }}</strong>
                    </span>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-6 pb-2">
                    <div class="form-group">
                        <label class="text-muted">SEARCH</label>
                        <div class="input-group search-field">
                            <input
                                type="text"
                                class="form-control"
                                v-model="searchTerm"
                                placeholder="Search the store"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                    <ul
                        class="search-results"
                        v-if="searchPricelistsbyTerm.length"
                    >
                        <li
                            v-for="prod in searchPricelistsbyTerm"
                            :key="prod.id"
                            @click="selectProduct(prod, 'term')"
                        >
                            <div class="row">
                                <div class="col-md-8">
                                    <span class="sku">{{ prod.sku }}</span>
                                    <span class="product-name">{{
                                        prod.product_name
                                    }}</span>
                                </div>
                                <div class="col-md-4 text-right">
                                    <span class="price"
                                        >${{
                                            $filters.moneyFormat(prod.price)
                                        }}</span
                                    >
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row" v-if="miscErrors.length > 0">
                <div
                    class="alert alert-danger my-1 col-md-12"
                    role="alert"
                    v-for="(err, index) in miscErrors"
                    :key="index"
                >
                    {{ err }}
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <table class="table table-responsive orders">
                        <thead>
                            <tr>
                                <th style="width: 5em">SKU</th>
                                <th>Product Name</th>
                                <th style="width: 11em" class="text-center">
                                    Stock Available
                                </th>
                                <th style="width: 11em" class="text-center">
                                    Quantity
                                </th>
                                <th style="width: 10em" class="text-right">
                                    Unit Price
                                </th>
                                <th style="width: 10em" class="text-right">
                                    Subtotal
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(order, idx) in orders" :key="order.id">
                                <td>{{ order.sku }}</td>
                                <td>
                                    <b>{{ order.product_name }}</b>
                                </td>
                                <td class="text-center">
                                    {{ order.available_quantity }}
                                </td>
                                <td class="mobile-text-right">
                                    <div
                                        class="quantity-toggle d-flex align-items-center"
                                    >
                                        <input
                                            type="number"
                                            class="form-control border w-100"
                                            min="0"
                                            @change="calculate(idx)"
                                            v-model="order.quantity"
                                        />
                                        <div
                                            class="cursor-pointer pl-3"
                                            @click="removeItem(idx)"
                                        >
                                            <i
                                                class="fa fa-times"
                                                aria-hidden="true"
                                            ></i>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-right">
                                    <b
                                        >${{
                                            $filters.moneyFormat(
                                                order.unit_cost
                                            )
                                        }}</b
                                    >
                                </td>
                                <td class="text-right">
                                    <b v-if="order.quantity > 0"
                                        >${{
                                            $filters.moneyFormat(
                                                order.sub_total
                                            )
                                        }}
                                    </b>
                                    <b v-else> $0.00 </b>
                                </td>
                            </tr>
                            <tr
                                v-if="
                                    orders?.length > 0 &&
                                    currentLocation.prepay == 1
                                "
                            >
                                <td class="border-0" colspan="3">&nbsp;</td>
                                <td class="subtotal text-right" colspan="3">
                                    <label class="pr-3">SHIPPING FEE</label>
                                    <span class="h6"
                                        >${{
                                            $filters.moneyFormat(shippingFee)
                                        }}</span
                                    >
                                </td>
                            </tr>
                            <tr v-if="orders?.length > 0">
                                <td class="border-0" colspan="3">&nbsp;</td>
                                <td class="subtotal">
                                    <label>Total Items</label>
                                    <b class="pl-3">{{ totalQuantity }}</b>
                                </td>
                                <td class="subtotal text-right" colspan="2">
                                    <label class="pr-3">GRAND TOTAL</label>
                                    <span class="h6"
                                        >${{
                                            $filters.moneyFormat(
                                                totalCost + shippingFee
                                            )
                                        }}</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-8"></div>
                <div class="col-md-4">
                    <!-- <button @click="screen = 2" type="submit" class="btn btn-outline-orange text-orange text-uppercase float-end w-100" :class="orders?.length > 0 && po_number !== '' ? '' : 'disabled'">
                        Review Order
                    </button> -->
                    <button
                        @click="updateOrder"
                        type="submit"
                        class="btn btn-outline-orange text-orange text-uppercase float-end w-100"
                        :class="
                            orders?.length > 0 && po_number !== ''
                                ? ''
                                : 'disabled'
                        "
                    >
                        Update Order
                    </button>
                </div>
            </div>
        </div>
        <!-- SCREEN 2 : REVIEW ORDER -->
        <div v-else-if="screen == 2" class="col-sm-12 col-md-8">
            <h3 class="mb-0">Review Your Order</h3>
            <div class="row mt-4">
                <div class="col-md-12">
                    <div class="d-flex align-items-center py-2">
                        <label class="pr-3">PO Number: </label>
                        <h5>{{ po_number }}</h5>
                    </div>

                    <table class="table table-responsive orders">
                        <thead>
                            <tr>
                                <th style="width: 5em">SKU</th>
                                <th>Product Name</th>
                                <th style="width: 11em" class="text-right">
                                    Quantity
                                </th>
                                <th style="width: 10em" class="text-right">
                                    Unit Price
                                </th>
                                <th style="width: 10em" class="text-right">
                                    Subtotal
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="order in orders" :key="order.id">
                                <td>{{ order.sku }}</td>
                                <td>
                                    <b>{{ order.product_name }}</b>
                                </td>
                                <td class="text-right">
                                    <b>{{ order.quantity }}</b>
                                </td>
                                <td class="text-right">
                                    <b
                                        >${{
                                            $filters.moneyFormat(
                                                order.unit_cost
                                            )
                                        }}</b
                                    >
                                </td>
                                <td class="text-right">
                                    <b v-if="order.quantity > 0"
                                        >${{
                                            $filters.moneyFormat(
                                                order.sub_total
                                            )
                                        }}
                                    </b>
                                    <b v-else> $0.00 </b>
                                </td>
                            </tr>
                            <tr v-if="orders?.length > 0">
                                <td class="border-0" colspan="3">&nbsp;</td>
                                <td class="subtotal text-right" colspan="3">
                                    <label class="pr-3">SHIPPING FEE</label>
                                    <span class="h6"
                                        >${{
                                            $filters.moneyFormat(shippingFee)
                                        }}</span
                                    >
                                </td>
                            </tr>
                            <tr v-if="orders?.length > 0">
                                <td class="border-0" colspan="2">&nbsp;</td>
                                <td class="subtotal text-right">
                                    <label>Total Items</label>
                                    <b class="pl-3">{{ totalQuantity }}</b>
                                </td>
                                <td class="subtotal text-right" colspan="2">
                                    <label class="pr-3">GRAND TOTAL</label>
                                    <span class="h6"
                                        >${{
                                            $filters.moneyFormat(
                                                totalCost + shippingFee
                                            )
                                        }}</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row mt-5 submit-order-button">
                <div class="col-md-6"></div>
                <div class="col-md-2">
                    <button
                        @click="screen = 1"
                        type="submit"
                        class="btn btn-outline-secondary text-uppercase float-end w-100"
                    >
                        Go back
                    </button>
                </div>
                <div class="col-md-4">
                    <button
                        @click="updateOrder"
                        type="submit"
                        class="btn btn-outline-danger text-uppercase float-end w-100"
                    >
                        Submit Order
                    </button>
                </div>
            </div>
        </div>
        <!-- SCREEN 3 : THANK MESSAGE -->
        <div v-else class="col-sm-12 col-md-8">
            <h3 class="mb-4">Thanks!</h3>
            <p>
                We have received your order and your sales rep has been
                notified. Please continue to check your dealer portal for
                updates.
            </p>
            <div class="row mt-5">
                <div class="col-md-4">
                    <button
                        @click="backToDashboard"
                        type="submit"
                        class="btn btn-outline-danger text-uppercase float-end w-100"
                    >
                        Back to Dashboard
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-4"></div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

export default {
    props: ["id", "order_number"],
    emits: [],
    components: {},
    setup() {
        const store = useStore();

        let pricelists = computed(function () {
            return store.state.pricelists;
        });
        let user = computed(function () {
            return store.state.user;
        });
        let orderId = computed(function () {
            return store.state.orderId;
        });
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let orderInfo = computed(function () {
            return store.state.orderInfo;
        });

        function getAllPricelists(currentLocation) {
            store.dispatch("getAllPricelists", {
                pricelist_id: currentLocation.pricelist_id,
            });
        }

        function updateOrder(form) {
            store.dispatch("updateOrder", form);
        }

        onMounted(() => {});

        return {
            store,
            pricelists,
            user,
            orderId,
            currentLocation,
            orderInfo,
            updateOrder,
            getAllPricelists,
        };
    },
    data() {
        return {
            searchSKU: "",
            searchTerm: "",
            orders: [],
            screen: 1,
            po_number: "",
            thumbnail: [],
            thumbnailTemp: "",
            requestedDeliveryDate: new Date(),
            lowerLimit: new Date(),
            miscErrors: [],
            showPoAttachError: false,
        };
    },
    computed: {
        shippingFee() {
            // if (this.currentLocation.prepay == 0) {
            //     return 0;
            // }
            if (this.currentLocation.id == 0 || !this.hasShippingFee) {
                return 0;
            }

            let accessoryTotal = 0;
            let silencerTotal = 0;

            for (let x = 0; x < this.orders.length; x++) {
                if (
                    this.orders[x].sku[0] == "A" &&
                    this.orders[x].sku[1] == "C"
                ) {
                    accessoryTotal += this.orders[x].sub_total;
                } else if (
                    this.orders[x].sku[0] == "S" &&
                    this.orders[x].sku[1] == "U"
                ) {
                    silencerTotal += this.orders[x].sub_total;
                }
            }

            if (accessoryTotal >= 250 || silencerTotal >= 750) {
                return 0;
            }
            return 20;
        },
        searchPricelistsbyTerm() {
            if (this.searchTerm === "") {
                return [];
            }

            // let matches = 0;

            return this.pricelists.filter((prod) => {
                if (
                    prod.product_name
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    prod.sku
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                    // && matches < 10
                ) {
                    // matches++;
                    return prod;
                }
            });
        },
        totalQuantity() {
            let quantity = 0;
            this.orders.forEach((data, idx) => {
                if (data.quantity > 0) {
                    quantity += data.quantity;
                }
            });
            return quantity;
        },
        totalCost() {
            let sub_total = 0;
            this.orders.forEach((data, idx) => {
                if (data.sub_total > 0) {
                    sub_total += data.sub_total;
                }
            });
            return sub_total;
        },
        totalAccessoryQty() {
            let qty = 0;
            for (let x = 0; x < this.orders.length; x++) {
                if (this.orders[x].sku.includes("AC")) {
                    qty += this.orders[x].quantity;
                }
            }
            return qty;
        },
        hasShippingFee() {
            if (
                this.currentLocation.is_buy_group_dealer == 1 ||
                this.currentLocation.is_premier_dealer == 1
            ) {
                return true;
            }
            return false;
        },
    },
    mounted() {
        // this.getAllPricelists(this.orderInfo.location)
        // this.populatOrder()

        this.store
            .dispatch("getOrderByOrderNumber", {
                id: this.id,
                order_number: this.order_number,
            })
            .then((resp) => {
                console.log(this.orderInfo);
                if (this.orderInfo.pricelist_id != null) {
                    this.$store
                        .dispatch("getAllPricelists", {
                            pricelist_id: this.orderInfo.pricelist_id,
                        })
                        .then((res) => {
                            this.populatOrder();
                        });
                } else {
                    this.getAllPricelists(this.orderInfo.location).then(
                        (res) => {
                            this.populatOrder();
                        }
                    );
                }
            });
    },
    methods: {
        populatOrder() {
            this.po_number = this.orderInfo.po_number;
            this.orderInfo.line_items.forEach((data) => {
                this.orders.push({
                    id: data.id,
                    sku: data.sku,
                    product_name: data.name,
                    quantity: data.quantity,
                    unit_cost: data.unit_cost,
                    sub_total: data.total,
                    available_quantity:
                        data.available_inventory.quantity_on_hand_sico_stock <=
                        0
                            ? "Backorder"
                            : data.available_inventory
                                  .quantity_on_hand_sico_stock,
                });
            });
            this.thumbnailTemp = this.orderInfo.attachments;
            this.requestedDeliveryDate = new Date(
                this.orderInfo.requested_delivery_date
            );

            // show all price list items if buy group date id is present
            if (this.orderInfo.buy_group_dates_id != null) {
                let orderSkus = [];
                if (this.orders.length > 0) {
                    orderSkus = this.orders.map((item) => item.sku);
                }
                for (let x = 0; x < this.pricelists.length; x++) {
                    if (orderSkus.includes(this.pricelists[x].sku)) {
                        continue;
                    }
                    this.orders.push({
                        id: this.pricelists[x].id,
                        sku: this.pricelists[x].sku,
                        product_name: this.pricelists[x].product_name,
                        unit_cost: this.pricelists[x].price,
                        quantity: 0,
                        sub_total: 0,
                        available_quantity:
                            this.pricelists[x].available_quantity,
                    });
                }
            }
        },
        updateRow(val) {
            this.paginatedOrders = val;
        },
        selectProduct(product, type) {
            let tempOrder = {
                // 'id': product.id,
                sku: product.sku,
                product_name: product.product_name,
                unit_cost: product.price,
                quantity: 1,
                sub_total: product.price,
                available_quantity: product.available_quantity,
            };
            this.orders.push(tempOrder);
            type == "sku" ? (this.searchSKU = "") : (this.searchTerm = "");
        },
        calculate(idx) {
            this.orders.forEach((data, index) => {
                data.sub_total =
                    parseFloat(data.quantity) * parseFloat(data.unit_cost);
            });

            var that = this;
            setTimeout(() => {
                that.orders.forEach((data, idx) => {
                    data.sub_total =
                        parseFloat(data.quantity) * parseFloat(data.unit_cost);

                    if (this.orderInfo.buy_group_dates_id == null) {
                        if (data.quantity == 0) {
                            that.orders.splice(idx, 1);
                        }
                    }
                });

                // localStorage.setItem('orders', JSON.stringify(this.orders));
            }, 1000);
        },
        removeItem(idx) {
            this.orders.splice(idx, 1);
        },
        updateOrder() {
            // buy date validation
            if (!this.buyDateValidation()) {
                return;
            }

            /*
            this.showPoAttachError = false;

            if (this.thumbnail.length <= 0) {
                this.showPoAttachError = true;
                return;
            }*/

            // make sure orders without quantity are exluded
            let filteredOrders = this.getOrdersWithQuantity();

            let requestOrder = {
                // location_id: this.currentLocation.id,
                location_id: this.orderInfo.location_id,
                po_number: this.po_number,
                order: filteredOrders,
                total_items: this.totalQuantity,
                total_cost: this.totalCost + this.shippingFee,
                // sales_rep_email: this.user.sales_rep.email,
                id: this.orderInfo.id,
                requested_delivery_date: new Date(
                    this.requestedDeliveryDate
                ).toLocaleDateString(),
                order_type: "edit",
                shipping_fee: this.shippingFee,
            };
            // this.updateOrder(requestOrder)
            // localStorage.setItem('orders', JSON.stringify([]));
            // this.screen = 3;
            // this.$router.back();
            // this.store.dispatch("updateOrder", requestOrder).then((res) => {
            //     window.emitter.emit("alertSuccess", {
            //         message: "Order updated successfully!",
            //     });
            //     // this.$router.push({name: 'orderInfo', params: {order_number: 'record'}})
            //     this.$router.push({
            //         name: "orderInfo",
            //         params: {
            //             id: this.orderInfo.id,
            //             order_number: this.orderInfo.order_number,
            //         },
            //     });
            // });

            // UPDATE ORDER
            window.emitter.emit("changeLoaderStatus", true);
            axios.post("/api/update-order", requestOrder).then((resp) => {
                this.store.commit("setOrderInfo", resp.data.order);

                if (this.thumbnail.length > 0) {
                    const formData = new FormData();
                    formData.append("attachments", this.thumbnail[0]);
                    formData.append("id", this.orderInfo.id);

                    // UPLOAD ATTACHMENT
                    axios
                        .post("/api/upload-order-attachment", formData)
                        .then((response) => {
                            // SEND ORDER EMAIL
                            requestOrder.order_id = this.orderInfo.id;
                            axios
                                .post("/api/send-order-email", requestOrder)
                                .then((response) => {
                                    this.store.dispatch("getAllOrders", {
                                        location_id: requestOrder.location_id,
                                    });

                                    this.$router.push({
                                        name: "orderInfo",
                                        params: {
                                            id: this.orderInfo.id,
                                            order_number:
                                                this.orderInfo.order_number,
                                        },
                                    });

                                    window.emitter.emit(
                                        "changeLoaderStatus",
                                        false
                                    );
                                });
                        });
                } else {
                    // SEND ORDER EMAIL
                    requestOrder.order_id = this.orderInfo.id;
                    axios
                        .post("/api/send-order-email", requestOrder)
                        .then((response) => {
                            this.store.dispatch("getAllOrders", {
                                location_id: requestOrder.location_id,
                            });

                            this.$router.push({
                                name: "orderInfo",
                                params: {
                                    id: this.orderInfo.id,
                                    order_number: this.orderInfo.order_number,
                                },
                            });

                            window.emitter.emit("changeLoaderStatus", false);
                        });
                }
            });
        },
        backToDashboard() {
            this.$router.push({ name: "dashboard" });
        },
        onChangeThumbnail(e) {
            // this.thumbnail = e.target.files;
            // console.log('this.thumbnail', this.thumbnail)
            var myFile = e.target.files[0].name;
            console.log(myFile);
            var upld = myFile.split(".").pop();
            if (upld == "pdf") {
                // alert("File uploaded is pdf")
                this.thumbnail = e.target.files;
            } else {
                // alert("Only PDF are allowed")
                this.thumbnail = [];
                $("input[name=thumbnail]").val("");

                window.emitter.emit("alertSuccess", {
                    message: "Only PDF are allowed",
                    alertType: "error",
                });
            }
        },
        generateURL(file) {
            let fileSrc = URL.createObjectURL(file);
            setTimeout(() => {
                URL.revokeObjectURL(fileSrc);
            }, 1000);
            return fileSrc;
        },
        buyDateValidation() {
            this.miscErrors = [];

            if (this.orderInfo.buy_group_date == null) {
                return true;
            }

            // get the selected pricelist
            const plist = this.orderInfo.buy_group_date;

            let errors = [];

            // validate accessories minimum quantity (PER SKU)
            if (plist.accessories_minimum_quantity > 0) {
                for (let x = 0; x < this.orders.length; x++) {
                    if (
                        this.orders[x].sku.includes("AC") &&
                        this.orders[x].quantity <
                            plist.accessories_minimum_quantity &&
                        this.orders[x].quantity != 0
                    ) {
                        errors.push(
                            `A minimum quantity of ${plist.accessories_minimum_quantity} is required for each accessories.`
                        );
                        break;
                    }
                }
            }

            // validate suppressors minimum quantity
            if (plist.order_suppressor_minimum_quantity > 0) {
                let total_suppressor_qty = 0;
                for (let x = 0; x < this.orders.length; x++) {
                    if (this.orders[x].sku.includes("SU")) {
                        total_suppressor_qty += this.orders[x].quantity;
                    }
                }
                if (
                    total_suppressor_qty <
                    plist.order_suppressor_minimum_quantity
                ) {
                    if (
                        total_suppressor_qty == 0 &&
                        plist.accessories_minimum_quantity > 0 &&
                        this.totalAccessoryQty > 0
                    ) {
                    } else {
                        errors.push(
                            `A minimum total quantity of ${plist.order_suppressor_minimum_quantity} is required for the suppressors.`
                        );
                    }
                }
            }

            // validate item minimum quantity
            if (plist.minimum_quantity_per_item > 0) {
                let has_minimum_quantity = false;
                for (let x = 0; x < this.orders.length; x++) {
                    if (
                        this.orders[x].quantity >=
                        plist.minimum_quantity_per_item
                    ) {
                        has_minimum_quantity = true;
                    }
                    /*
                    if (
                        this.orders[x].quantity <
                        plist.minimum_quantity_per_item
                    ) {
                        errors.push(
                            `A minimum quantity of ${plist.minimum_quantity_per_item} is required for each item.`
                        );
                        break;
                    }*/
                }

                if (!has_minimum_quantity) {
                    errors.push(
                        `A minimum quantity of atleast ${plist.minimum_quantity_per_item} for one item is required.`
                    );
                }
            }

            if (plist.order_minimum > 0) {
                let total = this.totalCost + this.shippingFee;
                if (total < plist.order_minimum) {
                    errors.push(
                        `A minimum total of ${plist.order_minimum} is required for this order.`
                    );
                }
            }

            if (plist.require_all_items > 0) {
                for (let x = 0; x < this.pricelists.length; x++) {
                    let idx = this.orders.findIndex(
                        (item) => item.sku == this.pricelists[x].sku
                    );
                    if (idx == -1) {
                        errors.push(
                            `All items in the price list are required for this order`
                        );
                        break;
                    }
                }
            }

            if (errors.length > 0) {
                this.miscErrors = errors;
                return false;
            }

            return true;
        },

        getOrdersWithQuantity() {
            let filteredOrders = [];
            for (let x = 0; x < this.orders.length; x++) {
                if (this.orders[x].quantity > 0) {
                    filteredOrders.push(this.orders[x]);
                }
            }
            return filteredOrders;
        },
    },
};
</script>
